// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"c6e8ba5398--wrapper--2Cpb6"};